import React from "react";
import { ExtendButtonBase } from "@mui/material/ButtonBase";
import LoadingButton, { LoadingButtonTypeMap } from "@mui/lab/LoadingButton";

export const ActionButton: ExtendButtonBase<LoadingButtonTypeMap> = props => {
    return (
        <LoadingButton
            variant='outlined'
            color='secondary'
            disabled={ props.disabled || props.loading }
            { ...props }
        />
    );
}

